import type { Option } from '../GenericBloc/GenericRadioFilter/GenericRadioDropdown';
import { SURVEY_COMPLETION_TYPE } from './SurveyCompletionFilterType';

export const OPTION_LIST: Option<SURVEY_COMPLETION_TYPE>[] = [
  { value: SURVEY_COMPLETION_TYPE.COMPLETE_RESPONSES, label: 'has complete responses' },
  { value: SURVEY_COMPLETION_TYPE.INCOMPLETE_RESPONSES, label: 'has incomplete responses' },
];
